import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    statuses: [],
    status: {},
    new_status: {},
  },
  actions,
  mutations,
  getters,
};
